// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".NewForm_footerAction__znVkm .ant-form-item-control-input-content {\n  display: flex;\n  justify-content: flex-start; }\n  .NewForm_footerAction__znVkm .ant-form-item-control-input-content > *:not(:last-child) {\n    margin-right: 16px; }\n\n.NewForm_wrapper__3cOOw .ant-input {\n  max-width: 630px; }\n", ""]);
// Exports
exports.locals = {
	"footerAction": "NewForm_footerAction__znVkm",
	"wrapper": "NewForm_wrapper__3cOOw"
};
module.exports = exports;
